import React from 'react'
import Layout from '../components/Layout'
import SidebarLayout from '../components/Sidebar'
import SetRbtPage from '../components/SetRbtPage'

const SetRbt = () => {
  return (
    <Layout>
      <SidebarLayout>
      <SetRbtPage/>
      </SidebarLayout>
      </Layout>
  )
}

export default SetRbt